// extracted by mini-css-extract-plugin
export default {"typography":"index_typography__pfYfB","block":"index_block__nIYq+"};